exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".content[data-v-480daed4]{padding:30px}.header[data-v-480daed4]{margin-bottom:30px}.chart[data-v-480daed4]{height:500px}.mr[data-v-480daed4]{margin-right:5px}.info[data-v-480daed4]{margin-top:30px}", ""]);

// exports
